import { render, staticRenderFns } from "./AnnouncementList.vue?vue&type=template&id=5b0ab30e&scoped=true&lang=pug&"
import script from "./AnnouncementList.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0ab30e",
  null
  
)

export default component.exports